/* ════════════ THE TICKER MORGUE ════════════
   The fallout page's atmosphere: dead headlines drift across the
   screen at different speeds and depths, like a news ticker nobody
   was watching. Occasionally one flares crimson. History scrolling
   past while everyone scrolls past it. */

import { onPage } from "./router";

const REDUCED = matchMedia("(prefers-reduced-motion: reduce)").matches;

function tickerMorgue(signal: AbortSignal) {
  const c = document.querySelector<HTMLCanvasElement>("#ticker-morgue")!;
  const ctx = c.getContext("2d")!;

  const CRIMSON = "#ff3860";
  const GREY = "#9aa0a6";

  const HEADLINES = [
    "2022 · the messages were subpoenaed",
    "2023 · 6.9M genomes",
    "2023 · one bug, 2,700 orgs",
    "2024 · all call records",
    "2024 · ssns, hundreds of millions",
    "2024 · 190M medical files",
    "2024 · your car snitched",
    "2024 · the os took screenshots",
    "2025 · the backdoor got used",
    "2025 · dna on the auction block",
    "2025 · papers, please (online edition)",
    "2025 · uk asks for the keys",
  ];

  type Line = {
    text: string;
    x: number;
    y: number;
    vx: number; // px per frame, sign = direction
    size: number; // font px, doubles as depth
    col: string;
    flare: number; // frames of crimson flare left (grey lines only)
  };
  let lines: Line[] = [];

  const spawn = (onScreen = false): Line => {
    const isHot = Math.random() < 0.18;
    const size = 9 + Math.random() * 4;
    const dir = Math.random() < 0.5 ? 1 : -1;
    const speed = (0.12 + Math.random() * 0.3) * (size / 11);
    return {
      text: HEADLINES[Math.floor(Math.random() * HEADLINES.length)]!,
      x: onScreen ? Math.random() * c.width : dir > 0 ? -260 : c.width + 20,
      y: 20 + Math.random() * Math.max(40, c.height - 40),
      vx: dir * speed,
      size,
      col: isHot ? CRIMSON : GREY,
      flare: 0,
    };
  };

  const seed = () => {
    c.width = innerWidth;
    c.height = innerHeight;
    const count = Math.min(18, Math.floor((c.width * c.height) / 90000));
    lines = Array.from({ length: count }, () => spawn(true));
  };
  seed();
  addEventListener("resize", seed, { signal });

  const draw = () => {
    ctx.clearRect(0, 0, c.width, c.height);
    for (const l of lines) {
      const hot = l.col === CRIMSON || l.flare > 0;
      ctx.globalAlpha = hot ? 0.45 : 0.18 * (l.size / 13);
      ctx.fillStyle = l.flare > 0 ? CRIMSON : l.col;
      ctx.font = `${l.size}px "IBM Plex Mono", monospace`;
      ctx.fillText(l.text, l.x, l.y);
    }
    ctx.globalAlpha = 1;
  };

  if (REDUCED) {
    draw();
    return;
  }
  const tick = () => {
    if (signal.aborted) return;
    for (let i = 0; i < lines.length; i++) {
      const l = lines[i]!;
      l.x += l.vx;
      if (l.flare > 0) l.flare--;
      // a grey headline occasionally flares: somebody finally read it
      else if (l.col === GREY && Math.random() < 0.0004) l.flare = 90;
      if ((l.vx > 0 && l.x > c.width + 40) || (l.vx < 0 && l.x < -300)) {
        lines[i] = spawn();
      }
    }
    draw();
    requestAnimationFrame(tick);
  };
  tick();
}

onPage(tickerMorgue);
